import { combineReducers } from "redux";
import authentication from "./authenticationSlice";
import courseList from "./courseListSlice";
import courseModule from "./courseModuleSlice";
import lessonDetails from "./lessonDetailsSlice";
import lessonQuiz from "./lessonQuizSlice";
import keyTakeaway from "./keyTakeawaySlice";
import askCreator from "./askCreatorSlice";
import progress from "./moduleProgressSlice";
import reportVideo from "./reportVideoSlice";
import updateUserActivity from "./updateUserActivitySlice";
import feedback from "./feedbackSlice";
import onboardingUserDetails from "./onboardingUserDetails";
import walkthrough from "./walkthrough";
import bottomIllustration from "./bottomIllustration";
import subscriptionStatus from "./subscriptionStatusSlice";
import name from "./nameSlice";
import skillDetails from "./skillSlice";
import razorPayLearntubeX from "./razorPayLearntubeXSlice";
import timer from "./timerSlice";
import scholarshipDetails from "./scholarshipAppliedSlice";
import whiteList from "./whiteListSlice";
import razorPay from "./razorPaySlice";

const personaliseLessonsReducer = combineReducers({
  authentication,
  courseList,
  courseModule,
  lessonDetails,
  lessonQuiz,
  keyTakeaway,
  askCreator,
  progress,
  reportVideo,
  updateUserActivity,
  feedback,
  onboardingUserDetails,
  walkthrough,
  bottomIllustration,
  subscriptionStatus,
  name,
  skillDetails,
  razorPayLearntubeX,
  timer,
  scholarshipDetails,
  whiteList,
  razorPay,
});

export default personaliseLessonsReducer;
